import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'

// rsuite
import Table from 'rsuite/Table'
import Tag from 'rsuite/Tag'
import Toggle from 'rsuite/Toggle'
import Tooltip from 'rsuite/Tooltip'
import Whisper from 'rsuite/Whisper'

// includes
import Edit2 from '@rsuite/icons/Edit'
import TrashIcon from '@rsuite/icons/Trash'
import {isEmpty} from 'lodash'
import {toast} from 'react-toastify'
import {SortType} from 'rsuite-table/lib/@types/common'
import Pagination from 'rsuite/Pagination'
import IconButton from 'rsuite/esm/IconButton'
import {ItemType, StateParamsModel} from 'src/app/modules/common/Model'
import CheckPermissions from 'src/app/modules/common/checkPermission'
import DeleteModal from 'src/app/modules/common/components/deleteModal'
import DesignComponent from 'src/app/modules/common/components/designComponent'
import RSuiteTable from 'src/cms/helpers/components/rsuiteTable'
import * as serviceCategoryRedux from '../../serviceCategory/redux'
import {IServiceCategoryState} from '../../serviceCategory/redux'
import AddServiceCategory from './AddServiceCategory'

const ServiceCategoryOne = () => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [actionType, setActionType] = useState('Add')
  const {
    loading,
    singleEnableSuccess,
    singleDisableSuccess,
    enableSuccess,
    disableSuccess,
    toggleLoading,
    success,
    deleteSuccess,
    serviceCategory,
    sortServiceCategoryData,
  } = useSelector((state: any) => state.serviceCategoryOne)
  const [params, setParams] = useState<StateParamsModel>({
    page: 1,
    limit: 10,
  })
  const [checkedValues, setCheckedValues] = useState<Array<string>>([])
  const [editSelectedData, setEditCheckedData] = useState<any>()

  // alert modal
  const [alertOpen, setAlertOpen] = useState(false)
  const handleAlertOpen = () => setAlertOpen(true)
  const handleAlertClose = () => setAlertOpen(false)
  const [openSortModal, setOpenSortModal] = useState(false)

  const handleChangeLimit = (dataKey: number) => {
    setParams({
      ...params,
      limit: dataKey,
    })
  }

  const serviceCategoryData: IServiceCategoryState = useSelector(
    (state: any) => state.serviceCategoryOne
  )

  useEffect(() => {
    dispatch(serviceCategoryRedux.actions.getServiceCategory(params))
  }, [params])

  const enableServiceCategoryData = () => {
    if (!isEmpty(checkedValues)) {
      const formData = checkedValues.map((d: string) => ({
        id: d,
      }))
      dispatch(serviceCategoryRedux.actions.enableServiceCategory(formData))
    } else {
      toast.error('No data Selected')
    }
  }

  const disableServiceCategoryData = () => {
    if (!isEmpty(checkedValues)) {
      const formData = checkedValues.map((d: string) => ({
        id: d,
      }))
      dispatch(serviceCategoryRedux.actions.disableServiceCategory(formData))
    } else {
      toast.error('No data Selected')
    }
  }

  const ActionCell = ({rowData, dataKey, ...props}: any) => {
    function handleAction() {
      alert(`id:${rowData[dataKey]}`)
    }
    return (
      <Cell {...props} className='link-group'>
        <CheckPermissions type='Edit'>
          <Whisper placement='top' trigger='hover' speaker={<Tooltip>Edit</Tooltip>}>
            <IconButton
              appearance='subtle'
              onClick={() => {
                setEditCheckedData(rowData)
                setActionType('Edit')
                setOpen(true)
              }}
              icon={<Edit2 />}
              data-cy='edit-button'
            />
          </Whisper>
        </CheckPermissions>
        <CheckPermissions type='Delete'>
          <Whisper placement='top' trigger='hover' speaker={<Tooltip>Delete</Tooltip>}>
            <IconButton
              appearance='subtle'
              onClick={() => {
                handleAlertOpen()
                let serviceId = [rowData.id]
                setCheckedValues(serviceId)
              }}
              icon={<TrashIcon />}
              data-cy='delete-button'
            />
          </Whisper>
        </CheckPermissions>
        <Whisper placement='top' trigger='hover' speaker={<Tooltip>Status</Tooltip>}>
          <Toggle
            size='sm'
            disabled={toggleLoading}
            checked={rowData.status}
            onClick={() => handleToggleAction(rowData)}
            data-cy='toggle-button'
          />
        </Whisper>
      </Cell>
    )
  }

  const handleToggleAction = (data: {[key: string]: string}) => {
    data?.status
      ? dispatch(serviceCategoryRedux.actions.singleDisableServiceCategory({id: data.id}))
      : dispatch(serviceCategoryRedux.actions.singleEnableServiceCategory({id: data.id}))
  }

  const Cell = Table.Cell

  const handleClose = () => setOpen(false)

  const columns = [
    {
      label: 'S.N.',
      dataKey: 'sn',
      width: 60,
      cell: <Cell dataKey='sn' />,
    },
    {
      label: 'Name',
      dataKey: 'name',
      flexGrow: 1,
      cell: <Cell dataKey='name' />,
      sortable: true,
    },

    {
      label: 'Status',
      dataKey: 'status',
      width: 85,
      cell: (
        <Cell>
          {(rowData) =>
            rowData?.status ? (
              <Tag color='green' size='sm'>
                Active
              </Tag>
            ) : (
              <Tag color='red' size='sm'>
                Inactive
              </Tag>
            )
          }
        </Cell>
      ),
      sortable: false,
    },
    {
      label: 'Action',
      width: 150,
      align: 'center',
      cell: <ActionCell dataKey='id' />,
    },
  ]

  const handleChecked = (values: Array<string>) => {
    setCheckedValues(values)
  }

  useEffect(() => {
    if (deleteSuccess) {
      toast.success('Category type deleted successfully')
      dispatch(serviceCategoryRedux.actions.getServiceCategory(params))
    }
    if (enableSuccess) {
      toast.success('Category type enabled successfully')
      dispatch(serviceCategoryRedux.actions.getServiceCategory(params))
    }
    if (disableSuccess) {
      toast.success('Category type disabled successfully')
      dispatch(serviceCategoryRedux.actions.getServiceCategory(params))
    }
    handleChecked([])
    dispatch(serviceCategoryRedux?.actions.getServiceCategory(params))
  }, [deleteSuccess, success, enableSuccess, disableSuccess])

  useEffect(() => {
    if (singleEnableSuccess) {
      toast.success('Category type enabled successfully')
      dispatch(serviceCategoryRedux.actions.getServiceCategory(params))
    }
    if (singleDisableSuccess) {
      toast.success('Category type disabled successfully')
      dispatch(serviceCategoryRedux.actions.getServiceCategory(params))
    }
    handleChecked([])
  }, [singleDisableSuccess, singleEnableSuccess])

  const data = serviceCategoryData?.data?.serviceCategory
    ? serviceCategoryData?.data?.serviceCategory?.map((item: any, i: number) => ({
        sn: (params?.page - 1) * params?.limit + (i + 1),
        id: item.id,
        name: item.name,
        name_np: item.name_np,
        slug: item.slug,
        status: item.status,
        crmCode: item?.crmCode,
        items: !isEmpty(item?.items)
          ? item?.items
              ?.sort((a: {order: number}, b: {order: number}) => a?.order - b?.order)
              .map((item: {[key: string]: string}) => ({
                id: item.id,
                title: item?.title,
                image: item?.image,
              }))
          : [
              {
                id: '',
                title: '',
                image: '',
              },
            ],
      }))
    : []

  const handleSort = (dataKey: string, sortType?: SortType) => {
    setParams({...params, orderBy: dataKey, order: sortType})
  }

  const handleAddModal = () => {
    setEditCheckedData({})
    setOpen(true)
    setActionType('Add')
  }

  const handleDelete = () => {
    let serviceId = checkedValues?.map((value) => ({id: value}))
    dispatch(serviceCategoryRedux?.actions.deleteServiceCategory(serviceId))
    handleAlertClose()
  }

  const handleRefresh = () => {
    dispatch(serviceCategoryRedux.actions.getServiceCategory(params))
  }

  const handleGetAllData = () => {
    setParams({...params, limit: serviceCategoryData?.data?.meta?.total})
    dispatch(serviceCategoryRedux.actions.getServiceCategory(params))
  }

  const handleSubmitSort = (data: Array<ItemType>) => {
    let body = {
      serviceCategoryId: data?.map((item) => ({id: item?.keyId})),
    }
    dispatch(serviceCategoryRedux.actions.sortServiceCategory(body))
  }

  useEffect(() => {
    if (!isEmpty(sortServiceCategoryData) && success) {
      toast.success('Service category sorted successfully')
      dispatch(serviceCategoryRedux.actions.sortServiceCategoryReset())
      setParams({...params, limit: 10})
      dispatch(serviceCategoryRedux.actions.getServiceCategory(params))
      setOpenSortModal(false)
    }
  }, [sortServiceCategoryData, success])

  return (
    <>
      <div className='shadow p-3 bg-white rounded'>
        <DesignComponent
          moduleName='Service Category'
          params={params}
          setParams={setParams}
          handleRefresh={handleRefresh}
          handleAddModal={handleAddModal}
          handleAlertOpen={handleAlertOpen}
          exportShow={false}
          importShow={false}
          enableMultiple={enableServiceCategoryData}
          disableMultiple={disableServiceCategoryData}
          data={data}
          sortShow={true}
          sortButtonName='Sort'
          handleSubmitSort={handleSubmitSort}
          handleGetAllData={handleGetAllData}
          openSortModal={openSortModal}
          setOpenSortModal={setOpenSortModal}
          loading={loading}
        />

        <div className='datatable'>
          <RSuiteTable
            onChecked={handleChecked}
            showCheckbox={true}
            columns={columns}
            data={data}
            showLoading={serviceCategoryData?.loading}
            checkedValues={checkedValues}
            handleSort={handleSort}
          />
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            className='mt-5'
            maxButtons={5}
            size='sm'
            layout={['total', '-', 'limit', '|', 'pager', 'skip']}
            total={serviceCategoryData?.data?.meta?.total || 0}
            limitOptions={[10, 20, 50, 100]}
            limit={params?.limit}
            activePage={params?.page}
            onChangePage={(value) => setParams({...params, page: value})}
            onChangeLimit={handleChangeLimit}
          />
          {open && (
            <AddServiceCategory
              open={open}
              params={params}
              handleClose={handleClose}
              actionType={actionType}
              editSelectedData={editSelectedData}
            />
          )}
        </div>
        <>
          {alertOpen &&
            (!isEmpty(checkedValues) ? (
              <DeleteModal
                handleClick={() => handleDelete()}
                isOpen={alertOpen}
                handleClose={() => handleAlertClose()}
              />
            ) : (
              toast.error('No data selected') && setAlertOpen(false)
            ))}
        </>
      </div>
    </>
  )
}
export default ServiceCategoryOne
